import React from "react";
import {
  Button
} from "reactstrap";
import classNames from "classnames/bind";
import assetPath from "~/utils/assetPath";
import { getCookie, saveCookie } from "~/utils/cookie";
import LinkComponent from "~/components/LinkComponent";

export function homeButtonElement() {
  return (
    <Button
      className="home_button"
      key="home"
      onClick={this.handleHomeTap}
      tag={LinkComponent}
      to={"https://online-jigsaw-puzzles.com/"}
      title={is.not.inArray(this.state.breakpoint, ["xs", "sm"]) ? "" : "Jigsaw Puzzles"}
    >
      <img alt="Home" src={assetPath("frontpage", "png")} />
      <span>Jigsaw Puzzles</span>
    </Button>
  );
}

export function backButtonElement() {
  return (
    <Button
      className="back_button"
      key="back"
      onClick={this.handleBackTap}
      title={is.not.inArray(this.state.breakpoint, ["xs", "sm"]) ? "" : "Back"}
    >
      <img alt="Back" src={assetPath("back", "png")} />
      <If condition={is.not.inArray(this.state.breakpoint, ["xs", "sm"])}>
        <span>Back</span>
      </If>
    </Button>
  );
}

export function settingsButtonElement() {
  return (
    <Button
      className="settings_button"
      key="settings"
      onClick={this.handleSettingsTap}
      title={is.not.inArray(this.state.breakpoint, ["xs", "sm"]) ? "" : "Settings"}
    >
      <img alt="Settings" src={assetPath("settings", "png")} />
      <If condition={is.not.inArray(this.state.breakpoint, ["xs", "sm"])}>
        <span>Settings</span>
      </If>
    </Button>
  );
}

export function helpButtonElement() {
  return (
    <Button
      className={classNames("help_button")}
      key="help"
      onClick={this.handleHelpTap}
      title={is.not.inArray(this.state.breakpoint, ["xs", "sm"]) ? "" : "Help"}
    >
      <img alt="Information" src={assetPath("info", "png")} />
      <If condition={is.not.inArray(this.state.breakpoint, ["xs", "sm"])}>
        <span>Help</span>
      </If>
    </Button>
  );
}

export function edgesButtonElement() {
  return (
    <Button
      className={classNames("edges_button", { inactive: !(this.props.isEdgesActive && this.props.isGameActive) })}
      key="edges"
      onClick={this.handleEdgesTap}
      title={is.not.inArray(this.state.breakpoint, ["xs", "sm"]) ? "" : "Toggle edges"}
    >
      <img alt="Edges" src={(this.props.isEdgesActive && this.props.isGameActive) ? assetPath("edges", "png") : assetPath("edges_grey", "png")} />
      <If condition={is.not.inArray(this.state.breakpoint, ["xs", "sm"])}>
        <span>Edges</span>
      </If>
    </Button>
  );
}

export function previewButtonElement() {
  return (
    <Button
      className={classNames("preview_button", { inactive: !(this.props.isPreviewActive && this.props.isGameActive) })}
      key="preview"
      onClick={this.handlePreviewTap}
      title={is.not.inArray(this.state.breakpoint, ["xs", "sm"]) ? "" : "Toggle preview"}
    >
      <img alt="Preview" src={(this.props.isPreviewActive && this.props.isGameActive) ? assetPath("preview", "png") : assetPath("preview_grey", "png")} />
      <If condition={is.not.inArray(this.state.breakpoint, ["xs", "sm"])}>
        <span>Preview</span>
      </If>
    </Button>
  );
}

export function shuffleButtonElement() {
  return (
    <Button
      className={classNames("shuffle_button", { inactive: !this.props.isGameActive })}
      key="shuffle"
      onClick={this.handleShuffleTap}
      title={is.not.inArray(this.state.breakpoint, ["xs", "sm"]) ? "" : "Shuffle pieces"}
    >
      <img alt="Shuffle" src={this.props.isGameActive ? assetPath("shuffle", "png") : assetPath("shuffle_grey", "png")} />
      <If condition={is.not.inArray(this.state.breakpoint, ["xs", "sm"])}>
        <span>Shuffle</span>
      </If>
    </Button>
  );
}

export function scoreContainerElement() {
  return (
    <div
      className="score_container"
      key="score"
    >
      <div
        className={classNames({
          hidden: is.falsy(
            getCookie("settingsShowTime", true)
          )
        })}
      >
        <p className="time">Time: 00:00</p>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/MenuComponent/helpers/elements.js